import React from 'react'
import CustomDateRangePicker from './CustomDateRangePicker'
import CustomTextField from './CustomTextField'

const MobileCustomFilter = ({
	itemsPerPage,
	handleItemsPerPageChange,
	startDate,
	endDate,
	handleDateChange,
	handleSubmit,
	searchTerm,
	handleSearch,
}) => {
	return (
		<div className='card container-fluid card-body pt-1'>
			<div className=' container-fluid w-100 card-body pt-2 mb-2'>
				<div className='d-flex justify-content-evenly align-items-center gap-2 pt-0'>
					<div>
						<div class='input-group input-group-outline  ' aria-label='Default select example'>
							<select
								className='dataTable-selector border-radius-lg dropdown-toggle w-100'
								id='exampleFormControlSelect1'
								value={itemsPerPage}
								onChange={handleItemsPerPageChange}
							>
								<option value={50}>50</option>
								<option value={100}>100</option>
								<option value={200}>200</option>
								<option value={300}>300</option>
								<option value={400}>400</option>
							</select>
						</div>
					</div>
					<div>
						<div class='input-group input-group-outline  ' aria-label='Default select example'>
							<CustomDateRangePicker startDate={startDate} endDate={endDate} handleDateChange={handleDateChange} />
						</div>
					</div>
					<div>
						<div class='input-group input-group-outline  ' aria-label='Default select example'>
							<input type='text' className='form-control' placeholder='Search...' value={searchTerm} onChange={handleSearch} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MobileCustomFilter
